import { Component, OnInit, AfterViewInit } from '@angular/core';
import { NaviService } from '../../services/navi.service';
import { HCPStatisticService } from '../../services/hcpstatistic.service';
import { BasicError } from '../../models/error/error';

import { ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';

import { Study } from '../../models/study';
import { User } from '../../models/user';
import { HCPPendingRequest } from '../../models/hcppending-request'
import { HCPGroupService } from '../../services/hcpgroup.service';
import { GroupService } from '../../services/group.service';
import { UserService } from '../../services/user.service';
declare var $: any;

@Component({
  selector: 'app-group-details-member',
  templateUrl: './group-details-member.component.html',
  styleUrls: ['./group-details-member.component.css']
})
export class GroupDetailsMemberComponent implements OnInit, AfterViewInit {
  public studyId: any;
  public users: User[] = [];
  public usersMap = {};
  public isEmptyUser = false;

  public datatable = null;
  public lastUpdateCount = 0;
  public timeout = null;

  public detailViewUrl = 'hcp/members/';
  public deletionUser: User = null;
  public deletedSuccess = null;
  public deletedUsers = {};

  public allusers = null;
  public allusersLoading = false;
  public lastUpdateCountAllUsers = 0;
  public lastUpdateCountAllRequests = 0;
  public timeoutAllUsers = null;
  public timeoutAllRequests = null;
  public inviteButtonClass = '';
  public inviteButtonText = 'Teilnehmer einladen';
  public invitedUsers = {};

  public pendingRequests = [];
  public deletePending: HCPPendingRequest = null;
  public deletePendingSuccess = null;

  public currentStudy: Study = null;
  constructor(private naviService: NaviService, private statistics: HCPStatisticService,
    private route: ActivatedRoute, private location: Location, private hcpGroup: HCPGroupService, private groupService: GroupService,
    private userService: UserService) { }

  ngOnInit() {
    this.users = [];
    this.route.paramMap.switchMap((params: ParamMap) => {
      this.studyId = params.get('id');
      this.getStudy(this.studyId);
      return this.hcpGroup.getMembersOfStudy(params.get('id'))
    }).subscribe(dd => {
      if (dd instanceof BasicError) {
        console.log('Error occured while reading study');
      } else if (dd instanceof Array) {
        const tmp = this.users.concat(dd);
        this.users = [];

        // Generating Usermap
        for (const u of tmp) {
          this.usersMap[u.getID().toString()] = u;
        }

        $('#datatable').dataTable().fnDestroy();

        this.users = tmp;

        if (this.users.length !== 0) {
          this.isEmptyUser = false;
        }
      }
    });

    if (this.users.length === 0) {
      this.isEmptyUser = true;
    }
  }

  ngAfterViewInit() {
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }

  /**
   * This function gets the actual study
   * @param studyId id of group
   */
  public getStudy(studyId: Study) {
    this.groupService.getGroupDetail(studyId.toString()).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Error occured while reading study');
      } else if (data instanceof Study) {
        this.currentStudy = data;
        this.getPendingRequests();
      }
    });
  }

  /*
  Called after last element was rendered
  */
  public updateRows() {
    if (this.lastUpdateCount !== this.users.length) {
      this.lastUpdateCount = this.users.length;

      if (this.timeout !== null) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(function () {
        $('#datatable').DataTable({
          'destroy': true,
          'pageLength': 25
        });
      }, 200);


    }
  }

  /**
   * Redirect to the detailed view of user
   * @param userId userid of user
   */
  public loadDetails(userId) {
    const url = this.detailViewUrl + userId + '/studies/' + this.studyId;
    this.naviService.navigateToUrl(url, 'hcpgroup');
  }


  /**
   * Prepare user to be removed
   * @param user User to get Deleted
   */
  public prepareDeletion(user: User) {
    this.deletedSuccess = null;
    this.deletionUser = user;

    $('#ModalDeleteFromGroup').modal();
  }

  /**
   * Removing user from study
   * @param user User to be removed from study
   */
  public deleteUser(user: User) {
    if (this.deletionUser === null || this.deletionUser.getID().toString() !== user.getID().toString()) {
      return;
    }

    this.hcpGroup.removeMembersFromStudy(this.currentStudy, [user.getID()]).subscribe(data => {
      if (data) {
        this.deletedSuccess = true;
        this.deletedUsers[user.getID().toString()] = true;
      } else {
        console.log('Failed to remove');
        this.deletedSuccess = false;
      }
    });
  }


  /**
   * This function updates the Rows with Userobj from all Users in the datatable
   */
  public updateRowsAllUsers() {
    if (this.lastUpdateCountAllUsers !== this.allusers.length) {
      this.lastUpdateCountAllUsers = this.allusers.length;

      if (this.timeoutAllUsers !== null) {
        clearTimeout(this.timeoutAllUsers);
      }

      this.timeoutAllUsers = setTimeout(function () {
        $('#datatableAllUsers').DataTable({
          'destroy': true,
          'pageLength': 10
        });
      }, 10);

    }
  }


  /**
   * This function updates the Rows with Userobj from all Users in the datatable
   */
  public updateRowsAllRequests() {
    if (this.lastUpdateCountAllRequests !== this.pendingRequests.length) {
      this.lastUpdateCountAllRequests = this.pendingRequests.length;

      if (this.timeoutAllRequests !== null) {
        clearTimeout(this.timeoutAllRequests);
      }

      this.timeoutAllRequests = setTimeout(function () {
        $('#datatableAllRequests').DataTable({
          'destroy': true,
          'pageLength': 10
        });
      }, 10);

    }
  }

  /**
   * This function displays the invite button formular
   * (At first it loads all users)
   */
  public inviteMembersModal() {
    if (this.allusers !== null) {
      // all users already loaded, start showing modal window
      $('#ModalNameList').modal();
      return;
    }

    if (this.allusersLoading) {
      // allusers are being loaded already
      return;
    }

    this.allusersLoading = true;
    this.inviteButtonClass = 'user-loading';
    this.inviteButtonText = 'Benutzerliste wird geladen';
    this.allusers = [];

    this.userService.getAllUsers().subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Error occured while reading all users');
      } else if (data instanceof Array) {
        const tmp = this.allusers.concat(data);
        this.allusers = [];

        $('#datatableAllUsers').dataTable().fnDestroy();

        this.allusers = tmp;
      }

      this.allusersLoading = false;
      this.inviteButtonClass = '';
      this.inviteButtonText = 'Teilnehmer einladen';
      $('#ModalNameList').modal();
    });
  }

  /**
   * Function to show all requests modal
   */
  public showAllRequestsModal() {
    $('#ModalRequestsList').modal();
  }

  /**
   * Adding user to the list of members
   * @param user user to be added
   */
  public addMemberToStudy(user: User) {
    this.hcpGroup.addMemberToStudy(this.currentStudy, [user.getID()]).subscribe(data => {
      if (data) {
        // Successfully added
        this.invitedUsers[user.getID().toString()] = user;
      } else {
        console.log('Failed to add user to the list of members');
      }
    });
  }

  /**
   * Getting all pending request for this study
   */
  public getPendingRequests() {
    this.hcpGroup.getPendingRequests(this.currentStudy).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Failed to get pending requests');
        console.log(data);
      } else {
        this.pendingRequests = data;
      }
    });
  }

  /**
   * Accpeting a pending request
   * @param pendingRequest pending Request to accept
   */
  public acceptPendingRequest(pendingRequest: HCPPendingRequest) {
    if (pendingRequest === undefined) {
      return;
    }

    this.hcpGroup.acceptPendingRequest(this.currentStudy, pendingRequest).subscribe(result => {
      if (result) {
        // Removing pending request from lists
        const index = this.pendingRequests.indexOf(pendingRequest, 0);
        if (index > -1) {
          $('#datatableAllRequests').dataTable().fnDestroy();
          this.pendingRequests.splice(index, 1);
          this.lastUpdateCountAllRequests = 0;
        }
        this.lastUpdateCount = 0;
        $('#datatable').dataTable().fnDestroy();
        this.users.push(pendingRequest.getUser());
      } else {
        // failed
        console.log('Could not accept pending request');
      }
    });
  }

  /**
   * prepare deletion of pending request
   * @param pending pending request to be deleted
   */
  public prepareModalDeleteRequest(pending: HCPPendingRequest) {
    this.deletePendingSuccess = null;
    this.deletePending = pending;
    $('#ModalDeleteRequest').modal();
  }

  /**
   * Deleting a pending request
   * @param pendingRequest pending request to be deleted
   */
  public deletePendingRequest(pendingRequest: HCPPendingRequest) {
    if (pendingRequest === undefined) {
      return;
    }

    this.hcpGroup.deletePendingRequest(this.currentStudy, pendingRequest).subscribe(result => {
      if (result) {
        // Deleting pending request was successful
        const index = this.pendingRequests.indexOf(pendingRequest, 0);
        if (index > -1) {
          $('#datatableAllRequests').dataTable().fnDestroy();
          this.pendingRequests.splice(index, 1);
          this.lastUpdateCountAllRequests = 0;
          this.deletePendingSuccess = true;
        }
      } else {
        // Deleting pending request failed
        console.log('failed to delete pending request');
        this.deletePendingSuccess = false;
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/group-details-member/group-details-member.component.ts